import { IconStats } from "@/components/design-system/icons/IconStats";
import { IconLaunch } from "@/components/design-system/icons/IconLaunch";
import { IconCommunity } from "@/components/design-system/icons/IconCommunity";
import { type BenefitItem } from "@/components/design-system/BenefitCard/BenefitCard";

export const benefits: readonly BenefitItem[] = [
  {
    Icon: IconStats,
    title: "Uncover Held-Away Assets",
    description:
      "Bravo surfaces retirement accounts, brokerage positions, and idle cash that sit outside your advisory relationship — turning everyday participant conversations into structured advisor opportunities.",
  },
  {
    Icon: IconLaunch,
    title: "Increase Rollover Conversion",
    description:
      "Most rollover windows close before advisors even know they're open. Bravo flags job-change intent in real time — so your team can act before the moment passes.",
  },
  {
    Icon: IconCommunity,
    title: "Elevate Every Advisory Meeting",
    description:
      "The Advisor Intelligence Brief gives your team a full participant financial picture before every meeting — so every conversation starts at a higher level, with context that drives conversion.",
  },
];
